import React, { ComponentType } from 'react';
import { Navigate } from 'react-router';
import APP_ROUTES from '@hkm/constants/routing.constants';
import { FeatureToggle } from '@hkm/shared/enum/featureToggle';
import { useHasRequiredFeatureToggles } from '@hkm/shared/hooks/useHasRequiredFeatureToggles';

export const requireFeatureToggles = (
  requiredFeatureToggles: Set<FeatureToggle>
): (<P extends object>(
  WrappedComponent: ComponentType<P>
) => ComponentType<P>) =>
  // eslint-disable-next-line react/display-name
  <P extends object>(WrappedComponent: ComponentType<P>): ComponentType<P> => (
    props: P
  ) => {
    const hasAccess = useHasRequiredFeatureToggles(requiredFeatureToggles);

    return hasAccess ? (
      <WrappedComponent {...props} />
    ) : (
      <Navigate to={APP_ROUTES.ACCESS_DENIED} />
    );
  };



// WEBPACK FOOTER //
// ./src/utils/routeGuards/requireFeatureToggles.tsx